// src/components/layout/ScrollToTop.tsx
import { useEffect } from 'react';
import { useLocation, useNavigationType } from 'react-router-dom';

/**
 * Every page starts at the top (55.86, the owner's report: scroll down the dashboard, open another page, and it
 * opened as far down). The router swaps the page but the window keeps its scroll; this puts it back to the top
 * whenever the page — the path — changes by a link or a button. Not on the browser's back and forward buttons
 * (POP): there the browser's own restoring of the position is what a player expects. A change of the query alone
 * (the department page's tabs and structure) is not a new page.
 */
export function ScrollToTop(): null {
    const { pathname } = useLocation();
    const type = useNavigationType();
    useEffect(() => {
        if (type !== 'POP') window.scrollTo(0, 0);
    }, [pathname, type]);
    return null;
}
